import api from '../api';

export default class PaisesService {
  constructor() {
    throw 'Não é possível instanciar PaisesService';
  }
  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }
}
const mergeEndpoint = () => {
  return `paises`;
};



// WEBPACK FOOTER //
// ./src/services/enums/paisesService.js